export const ELEVATION_UNITS = {
  ft: {
    name: "ft",
    multiplier: 3.28084,
  },
  m: {
    name: "m",
    multiplier: 1,
  },
};

export const SPEED_UNITS = {
  mph: {
    name: "mph",
    longName: "Miles per hour",
    multiplier: 2.236936,
  },
  kmh: {
    name: "km/h",
    longName: "Kilometers per hour",
    multiplier: 3.6,
  },
  knots: {
    name: "knots",
    longName: "Knots",
    description: "A knot is a unit of speed equal to one nautical mile per hour. A nautical mile is 1,852 meters.",
    multiplier: 1.94384,
  },
  ms: {
    name: "m/s",
    longName: "Meters per second",
    description: "Meters per second is the SI base unit of speed.",
    multiplier: 1,
    decimals: 1,
  },
  mach: {
    name: "mach",
    longName: "Mach",
    description:
      "Mach number is a ratio of the speed of a body (usually an aircraft) to the speed of sound in the undisturbed medium through which the body is traveling.",
    multiplier: 0.0029386,
    decimals: 3,
  },
};

export const ADDRESS_FIELDS = [
  {
    field: "formattedAddress",
    label: "Address",
  },
  {
    field: "locality",
    label: "City",
  },
  {
    field: "countySubdivision.fullName",
    label: "Township",
  },
  {
    field: "adminDistrict2",
    mapTitle: "County Map",
    label: "County",
    internationalLabel: "City/Region",
  },
  {
    field: "adminDistrict",
    mapTitle: "State Map",
    label: "State",
    internationalLabel: "State/Province",
  },
  {
    field: "postalCode",
    label: "ZIP Code",
    internationalLabel: "Postal Code",
  },
  {
    field: "countryRegion",
    label: "Country",
  },
  {
    field: "nativeLands",
    label: "Native Lands",
  },
  {
    field: "neighborhood",
    label: "Neighborhood",
  },
  {
    field: "zone.zone2023.name",
    label: "Plant Hardiness Zone",
  },
  {
    field: "intersectionName",
    label: "Intersection",
    class: "sm:col-span-2",
  },
  {
    field: "coordinates",
    label: "GPS coordinates",
  },
];

export const SCHOOL_DISTRICT_FIELDS = [
  {
    field: "neighborhood",
    label: "Neighborhood",
  },
  {
    field: "postalCode",
    label: "ZIP Code",
    internationalLabel: "Postal Code",
  },
  {
    field: "locality",
    label: "City",
  },
  {
    field: "countySubdivision.fullName",
    label: "Township",
  },
  {
    field: "adminDistrict2",
    mapTitle: "County Map",
    label: "County",
    internationalLabel: "City/Region",
  },
  {
    field: "adminDistrict",
    mapTitle: "State Map",
    label: "State",
    internationalLabel: "State/Province",
  },
];

export const USDA_ZONES = [
  {
    name: "1A",
    temp: "-60°F to -55°F",
    color: "#D6D6FF",
  },
  {
    name: "1B",
    temp: "-55°F to -50°F",
    color: "#C4C4F2",
  },
  {
    name: "2A",
    temp: "-50°F to -45°F",
    color: "#ABABD9",
  },
  {
    name: "2B",
    temp: "-45°F to -40°F",
    color: "#EBAFEB",
  },
  {
    name: "3A",
    temp: "-40°F to -35°F",
    color: "#E091EB",
  },
  {
    name: "3B",
    temp: "-35°F to -30°F",
    color: "#D07DDB",
  },
  {
    name: "4A",
    temp: "-30°F to -25°F",
    color: "#A66BFF",
  },
  {
    name: "4B",
    temp: "-25°F to -20°F",
    color: "#5B75ED",
  },
  {
    name: "5A",
    temp: "-20°F to -15°F",
    color: "#73A1FF",
  },
  {
    name: "5B",
    temp: "-15°F to -10°F",
    color: "#5EC8E0",
  },
  {
    name: "6A",
    temp: "-10°F to -5°F",
    color: "#46BB46",
  },
  {
    name: "6B",
    temp: "-5°F to 0°F",
    color: "#77C756",
  },
  {
    name: "7A",
    temp: "0°F to 5°F",
    color: "#ABD769",
  },
  {
    name: "7B",
    temp: "5°F to 10°F",
    color: "#CDDC70",
  },
  {
    name: "8A",
    temp: "10°F to 15°F",
    color: "#ECDB85",
  },
  {
    name: "8B",
    temp: "15°F to 20°F",
    color: "#ECCA57",
  },
  {
    name: "9A",
    temp: "20°F to 25°F",
    color: "#DBB64F",
  },
  {
    name: "9B",
    temp: "25°F to 30°F",
    color: "#F5B678",
  },
  {
    name: "10A",
    temp: "30°F to 35°F",
    color: "#EC9C36",
  },
  {
    name: "10B",
    temp: "35°F to 40°F",
    color: "#E7781F",
  },
  {
    name: "11A",
    temp: "40°F to 45°F",
    color: "#E6561E",
  },
  {
    name: "11B",
    temp: "45°F to 50°F",
    color: "#E98564",
  },
  {
    name: "12A",
    temp: "50°F to 55°F",
    color: "#D35A4E",
  },
  {
    name: "12B",
    temp: "55°F to 60°F",
    color: "#B41228",
  },
  {
    name: "13A",
    temp: "60°F to 65°F",
    color: "#95301D",
  },
  {
    name: "13B",
    temp: "65°F to 70°F",
    color: "#741B08",
  },
];

export const SNOWFALL_MAP_LEGEND = [
  { name: "<1 in", color: "rgb(229, 238, 246)" },
  { name: "1 in", color: "rgb(189, 215, 231)" },
  { name: "2 in", color: "rgb(106, 175, 214)" },
  { name: "3 in", color: "rgb(46, 131, 191)" },
  { name: "4 in", color: "rgb(3, 104, 187)" },
  { name: "6 in", color: "rgb(0, 71, 153)" },
  { name: "8 in", color: "rgb(254, 254, 150)" },
  { name: "12 in", color: "rgb(254, 197, 2)" },
  { name: "18 in", color: "rgb(255, 136, 0)" },
  { name: "24 in", color: "rgb(220, 12, 0)" },
  { name: "30 in", color: "rgb(160, 0, 0)" },
  { name: "36 in", color: "rgb(105, 0, 0)" },
  { name: "48 in", color: "rgb(51, 0, 0)" },
  { name: "60 in", color: "rgb(205, 205, 255)" },
  { name: "72 in", color: "rgb(160, 141, 217)" },
  { name: "96 in", color: "rgb(125, 81, 167)" },
  { name: "120 in", color: "rgb(85, 21, 114)" },
  { name: ">120 in", color: "rgb(41, 0, 48)" },
];

export const SNOWFALL_SEASONAL_MAP_LEGEND = [
  { name: "<1 in", color: "rgb(229, 238, 246)" },
  { name: "1 in", color: "rgb(189, 215, 231)" },
  { name: "2 in", color: "rgb(106, 175, 214)" },
  { name: "6 in", color: "rgb(46, 131, 191)" },
  { name: "1 ft", color: "rgb(0, 71, 153)" },
  { name: "2 ft", color: "rgb(254, 254, 150)" },
  { name: "3 ft", color: "rgb(254, 197, 2)" },
  { name: "4 ft", color: "rgb(255, 136, 0)" },
  { name: "6 ft", color: "rgb(220, 12, 0)" },
  { name: "8 ft", color: "rgb(160, 0, 0)" },
  { name: "10 ft", color: "rgb(105, 0, 0)" },
  { name: "15 ft", color: "rgb(205, 205, 255)" },
  { name: "20 ft", color: "rgb(160, 141, 217)" },
  { name: "30 ft", color: "rgb(125, 81, 167)" },
  { name: "40 ft", color: "rgb(85, 21, 114)" },
  { name: "50+ ft", color: "rgb(41, 0, 48)" },
];

export const CICADAS_BBOX = [-98.826303, 30.175072, -69.927977, 43.642242];
